<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-15 11:49:17
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-12-01 11:27:18
 * @FilePath: /bpm-form/src/components/wgForm/widget-items/wg-text.vue
 * @Description: 描述
 -->

<template>
  <div widget-type="text">
    <div
      :class="options.customClass"
      :data-model="fieldName"
      v-html="textValue"
      class="text-content"></div>
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
  methods: {
    initVal(val) {
      const newVal = val || this.defaultValue;
      if (newVal) {
        this.text = (`${newVal}`).replace(/\n/g, '<br/>');
      }
    },
  },
};
</script>
